import classNames from 'classnames'

import ZaiTag from 'components/ZaiTag'
import { useAuth } from 'contexts/AuthContext'
import { useTranslate } from 'lib/tolgee'
import { getJobUpdatedDate } from 'utils/getJobUpdatedDate'

import JobPinsLimitStatus from './JobPinsLimitStatus'

/**
 * @param {Object} props
 * @param {JobWithFolders} props.job
 * @param {isActive} props.isActive
 */
export const JobTitle = props => {
  const { job, isActive } = props

  const t = useTranslate()
  const { plan } = useAuth()

  return (
    <div className="JobTitle-title-wrapper">
      <div className="JobTitle-title-flex">
        <h5 className={classNames('JobTitle-title', { active: isActive })}>{job.name}</h5>
        {job.isAutomaticallyGenerated && <ZaiTag />}
        <JobPinsLimitStatus job={job} plan={plan} />
      </div>
      <p className="JobTitle-subtitle" title={getJobUpdatedDate(job, t)}>
        {getJobUpdatedDate(job, t)}
      </p>
    </div>
  )
}
